/**
 * Enum representing all possible call end reasons returned from the backend.
 * Used across call list, filters, and mapping logic to ensure consistency.
 */
export enum CallReason {
    DEAL = 'call_reason_deal',
    BUSY = 'call_reason_busy',
    NOT_SELECTED = 'call_reason_not_selected',
    INVALID_NUMBER = 'call_reason_invalid_number',
    CALLBACK = 'call_reason_callback',
    INACTIVE = 'call_reason_inactive',
    CONTINUED_CALL = 'call_reason_continued_call',
    VOICEMAIL = 'call_reason_voicemail',
    REJECTED = 'call_reason_rejected',
}
